import * as Yup from "yup";

export const levelSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, "Nome do nível muito curto")
        .required("O nome do nível é obrigatório"),
    value: Yup.number().default(0),
    order: Yup.number().default(0),
    status: Yup.string().oneOf(["active", "inactive"]).default("active"),
});
